import SendToButton from "../../buttons/SendToButton";
import React from "react";
import styled from "styled-components";
import {useLocation} from "react-router-dom";
import GoToGuidedUpdateProjectButton from "../../buttons/GoToGuidedUpdateProjectButton";
import {useSelector} from "react-redux";
import {
    DASHBOARD_ROUTE,
    PROJECTS_ABSOLUTE_ROUTE,
    STRATEGY_ABSOLUTE_ROUTE
} from "../../../routes/routesName";
import {
    DisplayForPilotAndCopilot,
    DisplayForPilotCopilotAndMembers
} from "../../../permissions/DisplayAccordingToRole";
import {useNavigate} from "react-router";
import SendContributionButton from "../../buttons/SendContributionButton";
import LinksButton from "../../buttons/LinksButton";

const ButtonsContainer = ({setIsOpenShareWithModal, setIsOpenKanban, setIsOpenLinkModal}) => {

    const {id, pilot, copilot, axisSponsor} = useSelector(state => state.project)
    const currentUser = useSelector(state => state.currentUser)


    const navigate = useNavigate()

    const location = useLocation()

    const goToGuidedUpdate = () => {
        navigate(`/maj-projet/${id}`);
    }

    const getButtonsAccordingToPath = () => {
        const pathname = location.pathname
        if (pathname.startsWith(PROJECTS_ABSOLUTE_ROUTE) || location.pathname.startsWith(STRATEGY_ABSOLUTE_ROUTE) || location.pathname.startsWith(DASHBOARD_ROUTE)) {
            return (
                <>
                    <DisplayForPilotAndCopilot
                        pilot={pilot}
                        copilot={copilot}
                        hasException={axisSponsor ? axisSponsor.id === currentUser.id : false}
                        component={<GoToGuidedUpdateProjectButton goToGuidedUpdate={goToGuidedUpdate}/>}
                    />

                </>
            )
        }

    }

    return (
        <Container>
            <SendContributionButton openModal={() => setIsOpenKanban(true)}/>

            <DisplayForPilotAndCopilot
                pilot={pilot}
                copilot={copilot}
                hasException={axisSponsor ? axisSponsor.id === currentUser.id : false}
                component={
                    <SendToButton
                        openModal={() => setIsOpenShareWithModal(true)}
                    />}
            />
            <DisplayForPilotCopilotAndMembers
                hasException={axisSponsor ? axisSponsor.id === currentUser.id : false}
                component={<LinksButton setIsOpen={setIsOpenLinkModal}/>}
                />

            {getButtonsAccordingToPath()}
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  grid-column-start: 8;
  grid-column-end: 12;
  grid-row-start: 2;
  grid-row-end: 4;
  border-radius: 15px;
  padding: 1rem;
  align-items: center;
  justify-content: center;
  gap: 1em;
  background: var(--color-white);
`
export default ButtonsContainer